import { IRootState } from '../../../../store'
import { IImagingUltrasoundState } from '../store/ImagingUltrasound.types'

export const getImagingUltrasoundSelector = (state: IRootState): IImagingUltrasoundState => state.imagingUltrasound
